import React, { useEffect, useState } from 'react';

import { Button, Tooltip } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useResponsive } from '../hooks/useResponsive';
import { osmPicto, orthoPicto } from '../mapStyles';
import { setActiveBaseLayer } from '../store/actions/mapActions';


export const MaptypeContainer = () => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  const styles = {
    typeSelect: {
      display: 'flex',
      border: '0.3em solid',
      borderRadius : '1em',
      minWidth: isMobile ? '3em' : '4.3em',
      width: isMobile ? '3em' : '4.3em',
      height: isMobile ? '3em' : '4.3em',
      padding: 0,
      '&:hover': {
        color: '#666666',
        border: '0.3em solid',
      }
    }
  };

  const [valueToActive, setValueToActive] = useState('ortho-tiles');


  const activeBaseLayer = useSelector(state => state.map.activeBaseLayer);
  const dispatch = useDispatch();

  const nameTypeImage = value => {
    if (value === 'osm-tiles') {
      return 'map';
    } 
    if (value === 'ortho-tiles') {
      return 'satellite';
    }
  }; 

  
  const renderImage = () => {
    switch (activeBaseLayer) {
      case 'osm-tiles':
        return orthoPicto;
      case 'ortho-tiles':
        return osmPicto;
      default:
        return;
    }
  };

  useEffect(() => {
    if (activeBaseLayer === 'osm-tiles') {
      setValueToActive('ortho-tiles');
    }
    if (activeBaseLayer === 'ortho-tiles') {
      setValueToActive('osm-tiles');
    }
  }, [activeBaseLayer]);

  return (
    <Tooltip 
      title={
        <p style = {{
          fontSize: '1em',
        }}>
          {t(`background-map.show-${nameTypeImage(valueToActive)}`)}
        </p>
      } 
      placement={isMobile ? 'top-end' : 'bottom-start'}
      arrow>
      <Button 
        sx={styles.typeSelect} 
        aria-label={t(`background-map.show-${nameTypeImage(valueToActive)}`)}
        color='mapTypeActive'
        onClick={() => {
          dispatch(setActiveBaseLayer(valueToActive));
        }}
      >
        <img 
          aria-hidden={true} 
          src={renderImage()}
          style={{
            borderRadius: '.7em'
          }}
          width='100%'
          height='100%' 
        />
      </Button>
    </Tooltip>
  );
};